import type { AssetGroupKey, PositionCategory } from './types'

export const assetGroupKeys: AssetGroupKey[] = ['investment', 'real_estate']

export const assetGroups: Record<AssetGroupKey, string[]> = {
  investment: [
    'bank_balance',
    'building_saving_balance',
    'securities',
    'life_insurance',
    'pension_insurance',
    'other_investment',
  ],
  real_estate: [
    'condominium',
    'single_family_house',
    'apartment_building',
    'two_party_house',
    'office',
    'commercial',
    'other_real_estate',
  ],
}

export const positionCategories: PositionCategory[] = ['expenses', 'liabilities']
